import {
  Button,
  Card,
  Col,
  Flex,
  Row,
  Space,
  Table,
  Tag,
  Spin,
  Switch,
  Input,
  Typography,
  Avatar,
} from "antd";
import React, { useState } from "react";
import Title from "antd/es/typography/Title";
import { useEffect } from "react";
import { DeleteIcon, EditIcon } from "../../../../../assets/svg";
import { colors } from "../../../../../constants/colors";
import { useDispatch, useSelector } from "react-redux";
import { UnorderedListOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Spinner from "../../../../common/spinner/Spinner";
import Actions from "../../../../../redux/actions";
import { appConstConfig } from "../../../../../constants/config/appConstConfig";
import CategoriesFormDialog from "./CategoriesFormDialog";
import CategoriesDeleteDialog from "./CategoriesDeleteDialog";
import {
  deleteCategoryByIdAction,
  getCategoriesAction,
} from "../../../../../redux/services/categories/categoriesServices";
import { SearchOutlined } from "@ant-design/icons";
import useDebounce from "../../../../../hooks/useDebounce";
import { toastService } from "../../../../common/toast-messages/toast";

const Categories = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* table dependencies */
  const { categories } = useSelector((state) => state.categories);

  const [columns, setColumns] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const { debouncedValue: debouncedSearchValue, debounceLoading } = useDebounce(
    searchValue,
    500
  );
  const [pagination, setPagination] = useState({
    pageNo: appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
    pageSize: appConstConfig.DEFAULT_TABLE_PAGE_SIZE,
  });
  const paginationObj = {
    total: categories?.total,
    current: pagination?.pageNo,
    pageSize: pagination?.pageSize,
    onChange: (pageNo, pageSize) => setPagination({ pageNo, pageSize }),
    pageSizeOptions: appConstConfig.DEFAULT_PAGE_SIZE_OPTIONS_ARR,
    showSizeChanger: true,
  };
  /* table dependencies */

  /* dialog dependencies */
  const [openAddEditCategoriesDialog, setOpenAddEditCategoriesDialog] =
    useState(false);
  const [openCategoriesDeleteDialog, setOpenCategoriesDeleteDialog] =
    useState(false);
  /* dialog dependencies */

  /* function definition to get table data */
  const handleGetTableData = (tempPageNo, tempPageSize, isUpdateStatus = false) => {
    setLoading(true);
    const dataToBeSent = {
      page: debouncedSearchValue !== "" ? 1 : isUpdateStatus ? tempPageNo : pagination?.pageNo,
      limit: isUpdateStatus ? tempPageSize : pagination?.pageSize,
      search: debouncedSearchValue,
    };
    dispatch(getCategoriesAction(dataToBeSent)).then(() => {
      setLoading(false);
    });
  };
  /* function definition to get table data */

  useEffect(() => {
    handleGetTableData();
  }, [pagination, debouncedSearchValue]);

  /* initial dependencies rendering */
  useEffect(() => {
    /* table column config */
    const tempTableColumns = [
      {
        title: t("servicesList.category"),
        dataIndex: "name",
        key: "name",
        render: (_,record) => {
          return (
            <Flex gap="1rem" align="center">
              <Avatar
                shape="square" size={64}
                src={record?.image_url}
                key={record?.image_url}
                icon={<UnorderedListOutlined />}
              />
               {
                record?.name
            ? `${record?.name}`
            : "-"
               }
            </Flex>
          );
        },
      },
      {
        title: t("subCat"),
        dataIndex: "subcategories",
        key: "subcategories",
        render: (_, record) => {
          return (
            <Flex gap="small" justify="left" style={{ flexWrap: "wrap" }}>
              {_.map((subcategory, index) => (
                <Tag key={index}>{subcategory.name}</Tag>
              ))}
            </Flex>
          );
        },
      },
      {
        title: t("Modules.AutoCredit.status"),
        key: "action",
        align: "center",
        render: (_, record) => {

          return (
            <>
              <Switch
                defaultChecked={record?.is_active}
                value={record?.is_active}
                size="default"
                onChange={(e) => handleEditStatus(e, record)}
              />
            </>
          );
        },
      },
      {
        title: t("appointmentInfo.action"),
        key: "action",
        align: "center",
        render: (_, record) => {
          return (
            <>
              <Flex gap="small" justify="center">
                <Space size="middle">
                  <Button
                    type="text"
                    size="medium"
                    icon={<EditIcon fillColor={colors.slateGray} />}
                    onClick={(e) => handleAddEditDetails(e, record)}
                  />
                </Space>
              </Flex>
            </>
          );
        },
      },
    ];
    /* table column config */
    setColumns(tempTableColumns);
  }, [categories?.data]);
  /* initial dependencies rendering */

  const handleAddEditDetails = (e, row) => {
    setOpenAddEditCategoriesDialog(true);
    if (
      row?._id &&
      row?._id !== "" &&
      row?._id !== null &&
      row?._id !== undefined
    ) {
      const selectedcategoryId = row?._id;
      dispatch(
        Actions.createAction(Actions.SELECTED_CATEGORIES_ID, {
          selectedcategoryId,
        })
      );
    }
  };

  const handleEditStatus = async (e, row) => {
    dispatch(
      Actions.createAction(Actions.SELECTED_CATEGORIES_ID, {
        selectedcategoryId: "",
      })
    );
    if (
      row?._id &&
      row?._id !== "" &&
      row?._id !== null &&
      row?._id !== undefined
    ) {
      const selectedcategoryId = row?._id;
      const dataToBeSent = {
        selectedcategoryId,
        is_active: !row?.is_active,
      };

      try {
        await dispatch(deleteCategoryByIdAction(dataToBeSent))
        handleGetTableData(pagination.pageNo,pagination.pageSize, true)
  
      } catch (error) {
        toastService.error(error)
      }

      
    }
  };

  return (
    <div>
      <Flex vertical gap="2rem">
        <Flex align="center" justify="space-between">
          <Card
                  bordered
                  hoverable
                  style={{
                    width: 300,
                    padding: 0,
                    borderRadius: 20,
                    border: `1px solid ${colors.oceanBlue}`,
                  }}
                >
              <Row gutter={[24, 24]} align="middle" justify="center">
                <Col span={6}>
                  <Button
                    type="primary"
                    shape="circle"
                    size="middle"
                    icon={<UnorderedListOutlined style={{ fontSize: 22 }} />}
                    style={{ background: colors.oceanBlue }}
                  />
                </Col>
                <Col span={18}>
                  <Flex vertical>
                    <Typography.Title level={3}>
                      {t("Categories")}
                    </Typography.Title>
                    <Typography.Title
                      level={2}
                      style={{ margin: 0, color: colors.DarkMint }}
                    >
                      {`${categories?.total || 0}`}
                    </Typography.Title>
                  </Flex>
                </Col>
              </Row>
            </Card>
          <Button type="primary" onClick={(e) => handleAddEditDetails(e, null)}>
            {t("addCat")}
          </Button>
        </Flex>
        <Row gutter={[16, 16]}>
          <Col span={8} style={{ display: "flex", alignItems: "center" }}>
            <Input
              size="large"
              suffix={<SearchOutlined />}
              placeholder={t("CommonUtils.searchByCategory")}
              onChange={(event) => setSearchValue(event.target.value)}
            />
          </Col>
        </Row>
        {loading || debounceLoading ? (
          <Spinner />
        ) : (
          <Table
            dataSource={categories?.data}
            columns={columns}
            pagination={paginationObj}
          />
        )}
      </Flex>
      <CategoriesFormDialog
        open={openAddEditCategoriesDialog}
        onClose={() => {
          setOpenAddEditCategoriesDialog(false);
          handleGetTableData();
        }}
      />
      {/* <CategoriesDeleteDialog
        open={openCategoriesDeleteDialog}
        onClose={() => {
          setOpenCategoriesDeleteDialog(false);
          handleGetTableData();
        }}
      /> */}
    </div>
  );
};

export default Categories;
